var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 28,
    viewBox: "0 0 13 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H1.45615C2.425 0.5 3.33421 0.967897 3.89735 1.75629L11.7072 12.6901C12.4751 13.7651 12.4494 15.2158 11.6439 16.2629L3.90067 26.3291C3.33278 27.0674 2.4542 27.5 1.5228 27.5H0",
    stroke: "#DFE2E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowEnd);
export default __webpack_public_path__ + "static/media/ArrowEnd.90b17b12f2d171ba66bb0eb72f24300a.svg";
export { ForwardRef as ReactComponent };